import * as React from 'react'
import PlantHaltListPageView from '../PlantHaltListPageView'
import { RIC_SG_PLANT_CODE } from './config'

/**
 * Variante della pagina fermi impianto dedicata a San Giorgio Bluair (`ric-sg`).
 *
 * È volutamente un wrapper sottile: la pagina è una sola, parametrizzata dalla prop
 * `variant`. Quando la variante verrà promossa a pagina principale dell'impianto basterà
 * far arrivare `variant` dall'impianto selezionato invece che dalla rotta, senza toccare
 * la logica interna della pagina.
 */
const PlantHaltListRicSgPageView = (props: any) => <PlantHaltListPageView {...props} variant={RIC_SG_PLANT_CODE} />

export default PlantHaltListRicSgPageView
